import styled from '@emotion/styled';
import { space } from 'folio-common-components';
import { colors } from 'folio-design-tokens';

export const InfoBox = styled.div`
  background: ${colors.blueLight};
  border-radius: 8px;
  ${space([16], 'padding')}
`;
